'use client';

import { CheckboxWithLabel } from '@depop/web-ui-kit/CheckboxWithLabel';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import baseFilterStyles from '@/components/Filters/baseFilterStyles.module.css';

type YMALSaleFilterProps = {
  onSale?: boolean;
  onSaleFilterChange: (onSale?: boolean) => void;
};

export function YMALSaleFilter({
  onSale,
  onSaleFilterChange,
}: YMALSaleFilterProps) {
  const searchT = useTranslations('search');

  return (
    <CheckboxWithLabel
      className={clsx(baseFilterStyles.searchFilterTrigger, {
        [styles.saleFilterTrigger]: true,
        [baseFilterStyles.searchFilterTriggerActive]: onSale,
      })}
      label={searchT('OnSale')}
      checked={Boolean(onSale)}
      onChange={() => onSaleFilterChange(!onSale)}
    />
  );
}
